import React from 'react';
import { VStack } from 'native-base';
import { Modal } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';

export const ConfirmationModal = ({
    isOpen,
    onClose,
    giftCardValue
}: {
    isOpen: boolean,
    onClose: () => void,
    giftCardValue: number
}) => {

    return (
        <Modal isOpen={isOpen} onClose={() => onClose} closeable p={8}>
            <VStack alignItems="center">
                <Caption
                    text={'giftCard.confirmation_modal.complete'}
                    fontSize={'lg'}
                    fontWeight={'bold'}
                />
                <Caption fontSize={'2xl'}>
                    ${ giftCardValue }
                </Caption>
            </VStack>
        </Modal>
    );
};
